import { timeout, catchError, take, map } from "rxjs/operators";
import { BehaviorSubject, of, Subject, throwError, from, lastValueFrom } from "rxjs";
import { inject, Injectable, Injector } from "@angular/core";
import * as signalR from "@microsoft/signalr";
import { ApiService } from "./api.service";
import { NetworkserviceService } from "../Networkservice/networkservice.service";
import { ResourceObject, ChannelData } from "src/app/interfaces/interfaces";
import { KioskService } from "../hxa-device-services/kiosk.service";

@Injectable({
	providedIn: "root",
})
export class WebsocketService {
	private connection: signalR.HubConnection;
	private connectionwithoutAuth: signalR.HubConnection;
	public connectionId = new BehaviorSubject<string>(undefined);
	public licenseCallback = new Subject<boolean>();
	public messageReactionCallback = new BehaviorSubject<boolean>(undefined);
	public messageReplayCallback = new BehaviorSubject<string>(undefined);
	public resourceCallback = new Subject<ResourceObject>();
	public eventTriggerCallback = new Subject<string[]>();
	public socketStatus = new Subject<boolean>();
	public connectionStatus = new BehaviorSubject<boolean>(undefined);
	public removeCallback = new Subject();
	public removeConnectorCallback = new Subject<boolean>();
	public maintenanceModeCallback = new Subject<boolean>();
	private forceStop = false;
	private api: ApiService;
	public HubConnectionStatus = new BehaviorSubject<string>("");
	private readonly kioskService = inject(KioskService);
	constructor(private injector: Injector) {}
	createConnectionWithHubWithoutAuth(deviceHubEndPoint, serialNumber) {
		if (this.connectionwithoutAuth != undefined) {
			if (this.connectionwithoutAuth.state != "Connected") {
				const url = deviceHubEndPoint;
				this.connectionwithoutAuth = new signalR.HubConnectionBuilder()
					.withUrl(url)
					.withAutomaticReconnect()
					.build();

				this.connectionwithoutAuth
					.start()
					.then(() => {
						this.connectionwithoutAuth.invoke(
							"saveConnectionOfDevicesCode",
							serialNumber,
						);
					})
					.catch((err) => {});

				this.connectionwithoutAuth.on("sendDeviceType", (data) => {
					this.connectionwithoutAuth.invoke("ReceiveDeviceType", "DoorConnect", data); // Device send it's type to API
				});
			}
		} else {
			const url = deviceHubEndPoint;
			this.connectionwithoutAuth = new signalR.HubConnectionBuilder()
				.withUrl(url)
				.withAutomaticReconnect()
				.build();

			this.connectionwithoutAuth
				.start()
				.then(() => {
					this.connectionwithoutAuth.invoke("saveConnectionOfDevicesCode", serialNumber);
				})
				.catch((err) => {});

			this.connectionwithoutAuth.on("sendDeviceType", (data) => {
				this.connectionwithoutAuth.invoke("ReceiveDeviceType", "DoorConnect", data); // Device send it's type to API
			});
		}
		this.connectionwithoutAuth.onreconnected((connectionId) => {
			this.connectionwithoutAuth.invoke("saveConnectionOfDevicesCode", serialNumber);
		});
		this.connectionwithoutAuth.on("StartRemoteloginFromPortal", (data, ClientRequestId) => {
			if (data) {
				this.api = this.injector.get(ApiService);
				//this.loader$.next(true);
				this.api.relogin(ClientRequestId).pipe().subscribe();
			}
		});
	}

	saveConnectionIdViaDeviceCode(deviceCode) {
		this.connectionwithoutAuth.invoke("saveConnectionOfDevicesCode", deviceCode);
	}

	stopConnectiongWithoutAuth() {
		this.connectionwithoutAuth.stop();
	}

	createConnection(deviceHubEndpoint, accessToken, deviceId) {
		const url = deviceHubEndpoint;
		if (this.connection !== undefined && this.connection.state == "Disconnected") {
			this.connection = undefined;
		}
		if (this.connection === undefined) {
			this.connection = new signalR.HubConnectionBuilder()
				.withUrl(url, { accessTokenFactory: () => this.getToken() })
				.build();
			this.connection.on("LicenseCallback", (data) => {
				this.licenseCallback.next(true);
			});
			this.connection.on("ReactionCallback", (data) => {
				this.messageReactionCallback.next(data);
			});
			this.connection.on("ReplayCallback", (data) => {
				this.messageReplayCallback.next(data);
			});
			this.connection.on("ResourceCallback", (data) => {
				this.resourceCallback.next(data);
			});
			this.connection.on("EventTriggerCallback", (data) => {
				this.eventTriggerCallback.next(data);
			});
			this.connection.on("RemoveCallback", (data) => {
				this.removeCallback.next(true);
			});
			this.connection.on("RemoveConnectorCallback", (data) => {
				this.removeConnectorCallback.next(true);
			});
			this.connection.on("MaintenanceUpdateCallBack", async (isMaintenance: boolean) => {
				this.maintenanceModeCallback.next(isMaintenance);
			});
			this.connection.onreconnected((connectionId) => {
				const network = this.injector.get(NetworkserviceService);
				network.getLocalIPAddress().then((ip) => {
					if (ip) this.connection.invoke("ReportLocalIp", ip).catch(() => {});
				});
			});

			this.connection.onclose(() => {
				this.HubConnectionStatus.next("Closed");

				this.connection = undefined;
				if (!this.forceStop) {
					setTimeout(() => {
						this.socketStatus.next(false);
						this.connectionStatus.next(false);
						this.connectionId.next(null);
					}, 5000);
				} else {
					this.forceStop = false;
				}
			});

			return from(
				this.connection
					.start()
					.then(() => {
						this.HubConnectionStatus.next("Connected");
						const network = this.injector.get(NetworkserviceService);
						network.getLocalIPAddress().then((ip) => {
							if (ip) this.connection.invoke("ReportLocalIp", ip).catch(() => {});
						});
						return this.connection.invoke("HardwareAuthNew", deviceId);
					})
					.catch((err) => {
						throw err;
					})
					.then(() => {
						this.connectionStatus.next(true);
						this.connectionId.next(this.connection.connectionId);
						return true;
					})
					.catch((error) => {
						this.connection.stop().catch(() => {});
						throw error;
					}),
			).pipe(
				take(1),
				timeout(30000),
				catchError((err) => {
					this.connection = undefined;
					this.connectionStatus.next(false);
					this.connectionId.next(null);
					return throwError(err);
				}),
			);
		} else {
			return of(true);
		}
	}

	postMessage(
		message: string,
		channel: ChannelData,
		team: string,
		image: string,
		infoMessage: string,
		connectorId: string,
	) {
		return from(
			this.connection.invoke(
				"PostTeamMessage",
				connectorId,
				message,
				channel,
				team,
				image,
				infoMessage,
			),
		).pipe(
			map((x) => {
				return x;
			}),
		);
	}

	getMessageReaction(connectorId: string) {
		this.connection.invoke("GetMessageReaction", connectorId);
	}

	getMessageReplay(connectorId: string) {
		this.connection.invoke("GetMessageReplay", connectorId);
	}

	triggerAutomationFlow(soureHandleId: string) {
		this.connection.invoke("TriggerAutomationFlow", soureHandleId);
	}

	connectionClose() {
		if (this.connection !== undefined) {
			this.forceStop = true;
			this.connection.stop();
			this.connection = undefined;
		}
	}

	connectionCloseWithReconnect() {
		if (this.connection !== undefined) {
			this.connection.stop();
			this.connection = undefined;
		}
	}
	async getToken(): Promise<string> {
		this.api = this.injector.get(ApiService);
		const token: string = await lastValueFrom(this.api.refreshTokenRequest());
		return token;
	}
	reloginDevice(newcode: any, ClientRequestId: any) {
		this.connectionwithoutAuth.invoke("relogin", newcode, ClientRequestId);
	}
}
